/* eslint-disable */
import store from '@/store';


export default class ProgressLoader {
  constructor() {
    this.createLoaderInDOM();
    this.setDefault();
    this.setListner();
  }

  createLoaderInDOM() {
    const body = document.getElementById('body');
    let isLoaderContainerExist = true;
    let loaderContainer = document.getElementById('loader-container');
    let loaderStrip = document.getElementById('loader-strip');

    if (!loaderContainer) {
      isLoaderContainerExist = false;
      loaderContainer = document.createElement('div');
      loaderContainer.id = 'loader-container';
      loaderContainer.style.display = 'none';
      loaderContainer.classList.add('loader-container');
    }

    if (!loaderStrip) {
      loaderStrip = document.createElement('div');
      loaderStrip.id = 'loader-strip';
      loaderStrip.classList.add('loader-strip');
      loaderContainer.appendChild(loaderStrip);
    }

    if (!isLoaderContainerExist) {
      document.body.insertBefore(loaderContainer, body);
    }
  }

  updateLoaderInDOM() {
    document.getElementById('loader-strip').style.width = `${this.widthPercent}%`;
  }

  showLoader() {
    this.visible = true;
    document.getElementById('loader-container').style.display = 'block';
  }

  async hideLoader() {
    try {
      await this.waitTransitionDone();
    } catch (e) { }

    this.visible = false;
    document.getElementById('loader-container').style.display = 'none';
  }

  setDefault() {
    this.delay = 1;
    this.widthPercent = 0;
    this.waitPosition = 80;
    store.commit('setLoadTransition', false);
    this.state = 'query';
  }

  setListner() {
    const loaderStrip = document.getElementById('loader-strip');
    loaderStrip.addEventListener('transitionend', this.transitionEnd, false);
  }

  transitionEnd() {
    store.commit('setLoadTransition', false);
  }

  waitTransitionDone() {
    return new Promise((resolve, reject) => {
      const transitionInterval = setInterval(() => {
        if (!store.getters.isLoadTransitioned) {
          clearTimeout(this.rejectTimer);
          clearInterval(transitionInterval);
          resolve('done');
        }
      }, 100);

      this.rejectTimer = setTimeout(() => {
        this.isRun = false;
        this.hideLoader();
        store.commit('setLoadTransition', false);
        reject(new Error('timeout'));
      }, 30000);
    });
  }

  async run() {
    if (!this.visible) {
      return;
    }

    if (this.state === 'query') {
      this.delay *= 1.13;
      this.widthPercent += 1;

      if (this.widthPercent >= this.waitPosition) {
        this.delay *= 1.13;
      }
    }

    if (this.state === 'done') {
      this.widthPercent += 1;
    }

    if (this.state === 'error') {
      this.widthPercent -= 2;
    }

    if (this.pastPercent !== this.widthPercent) {
      this.pastPercent = this.widthPercent;
      store.commit('setLoadTransition', true);
    }

    if (this.widthPercent >= 100 || this.widthPercent < 0) {
      this.widthPercent = this.widthPercent > 0 ? 100 : 0;
      this.isRun = false;
      this.hideLoader();
    }

    this.updateLoaderInDOM();

    if (this.isRun) {
      setTimeout(() => { this.run(); }, this.delay);
    }
  }

  start() {
    this.setDefault();
    this.showLoader();
    this.isRun = true;
    this.run();
  }

  async done() {
    this.delay = 1;
    this.state = 'done';
    await this.run();

    try {
      await this.waitTransitionDone();
    } catch (e) { }

    this.setDefault();
    this.hideLoader();
  }

  async error() {
    this.delay = 1;
    this.state = 'error';
    await this.run();

    try {
      await this.waitTransitionDone();
    } catch (e) { }

    this.setDefault();
    this.hideLoader();
  }
}
